import type { RouteRecordRaw } from "vue-router"

export const SalesAssociateCollectionRoutes: RouteRecordRaw[] = [
  {
    path: "sales-associate-collection",
    children: [
      {
        path: "",
        component: () => import("./SalesAssociateCollectionCollectIdPage.vue"),
      },
    ],
  },
]
